import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import { string, func, oneOfType, number } from 'prop-types'
import { useHistory } from 'react-router-dom'
import { FileUploadModal, DialogContentStyled } from '@components'
import { colors } from '@global/constants'
import { api } from 'api'

export const BulkResubmitModal = ({ datasetId, onProgressClick = null, setOpen, ...rest }) => {
  const history = useHistory()

  const bulkResubmit = formData => {
    return api.post(`/api/v1/account/dataset/resubmission/${datasetId}/overwrite`, formData)
  }

  const updateProgressPath = () => {
    setOpen(false)
    if (datasetId) {
      onProgressClick(datasetId)
      return
    }
    history.push('/codes/submissions')
  }

  return (
    <FileUploadModal
      decorateActions={(defaultActions, { phase }) => {
        switch (phase) {
          case FileUploadModal.PHASES.START:
          case FileUploadModal.PHASES.ERROR:
            return (
              <>
                <div />
                {defaultActions}
              </>
            )
          case FileUploadModal.PHASES.SUCCESS:
            return (
              <>
                {defaultActions}
                <Button
                  name="view-progress"
                  onClick={updateProgressPath}
                  variant="outlined"
                  color="primary"
                  autoFocus
                >
                  {t`View progress`}
                </Button>
              </>
            )
        }
        return defaultActions
      }}
      onUpload={bulkResubmit}
      renderErrors={errors => (
        <>
          {map(errors, e => (
            <div>{e.defaultErrorMessage}</div>
          ))}
        </>
      )}
      SuccessPhase={SuccessPhase}
      setOpen={setOpen}
      title={t`Overwrite data in this submission`}
      {...rest}
    />
  )
}

const SuccessPhase = () => (
  <DialogContentStyled>
    <CheckCircleIcon style={{ color: colors.green.light, fontSize: '50px', margin: '20px' }} />
    <SuccessMessage>
      <Typography variant="h4">{t`Successfully uploaded!`}</Typography>
      <Typography variant="body1" style={{ padding: '20px 64px', textAlign: 'center' }}>
        <Trans>
          We've successfully started processing and validating your new data. Sit back and relax,
          we've got this. Just like before, we'll let you know if something goes wrong.
        </Trans>
      </Typography>
    </SuccessMessage>
  </DialogContentStyled>
)

// Styled Components

const SuccessMessage = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`

// Prop Types
BulkResubmitModal.propTypes = {
  datasetId: oneOfType([string, number]).isRequired,
  onProgressClick: func,
}
